import { message, notification } from 'tea-component';

// message 1.内容 2.存在时长 3.是否需要关闭按钮 4.提示类型 success error warning
export interface MessageTipProps {
  errorCode: number;
  content?: React.ReactNode;
  duration?: number;
  isClose?: boolean;
  type?: string;
}

export const showErrorMessagetip: (options: MessageTipProps) => void = (options: MessageTipProps) => {
  CommonMessagetip(options);
};

export const CommonMessagetip: (options: MessageTipProps) => void = ({ content, duration = 3000, isClose, type }) => {
  notification.error({
    className: 'downDataBox downData' + type,
    description: content,
    duration: duration
  });
  // const messageClose = message.warning({
  //   content: (
  //     <div style={{ color: 'red' }}>
  //       {content}
  //       {isClose && (
  //         <span
  //           className="close"
  //           onClick={() => {
  //             messageClose.hide();
  //           }}
  //         ></span>
  //       )}
  //     </div>
  //   ),
  //   duration,
  //   className: type,
  // });
};

export const ERROR_CODE_MESSAGE: Record<number, string> = {
  999: '系统错误',
};
